import moment from 'moment';
import { Account, BEAccount } from '../../../interfaces/account';
import { IPratica, StatoPratica } from '../../../interfaces/pratica';
import { Product } from '../../requests/models/product';
import { Channel } from '../canals/channel';
import { ChannelType } from '../canals/channel-type';

export interface BePraticaAggregator {
  canaleResponse: ChannelResponse | null;
  eroganteResponse: ChannelResponse | null;
  garanteResponse: ChannelResponse | null;
  praticaResponse: IPratica;
  prodottoResponse: Product[];
  user: Account;
}

export interface PraticaAggregator {
  canaleResponse: ChannelResponse | null;
  eroganteResponse: ChannelResponse | null;
  garanteResponse: ChannelResponse | null;
  praticaResponse: IPratica;
  prodottoResponse: Product[];
  user: Account;

  //properties added by the client when mapping the request response
  isDayOfStipula: boolean;
  hasBeenUpdatedInTheLast3Days: boolean;
  initials: string;
  fullName: string;
  isBoGaranteQuickEdit: boolean;
  isBoEroganteQuickEdit: boolean;
}

export interface ChannelResponse {
  id: string;
  nome: string;
  status: Channel['status'];
  type: ChannelType;
  timestampIns: number;
  timestampMod: number;
}

export class PraticaAggregator implements PraticaAggregator {
  isBoGaranteQuickEdit = false;
  isBoEroganteQuickEdit = false;
  isCdcQuickEdit = false;
  displayState?: StatoPratica;
  constructor(data: BePraticaAggregator, currentUser?: BEAccount) {
    this.canaleResponse = data.canaleResponse;
    this.eroganteResponse = data.eroganteResponse;
    this.garanteResponse = data.garanteResponse;
    this.praticaResponse = data.praticaResponse;
    this.prodottoResponse =
      data.prodottoResponse.map((prod) => {
        const importoCP = prod.kpi?.Modulo_3?.find(
          (kpi) => kpi.Descrizione === 'M3_IMPORTO_FINANZIAMENTO'
        )?.Valore;
        return {
          ...prod,
          importoCP: isNaN(Number(importoCP)) ? undefined : importoCP,
        };
      }) || [];
    this.user = data.user;

    let stipulaDate: moment.Moment | undefined = undefined;
    if (data.prodottoResponse?.[0]?.dataPrenotazioneStipula) {
      stipulaDate = moment(data.prodottoResponse?.[0]?.dataPrenotazioneStipula);
    }

    let now = moment();
    let isStipulaDay = stipulaDate && now.isSame(stipulaDate, 'day');

    let isInStipula =
      data.praticaResponse.stato === StatoPratica.IN_STIPULA && isStipulaDay;

    let lastUpdated = moment(data.praticaResponse.dataCambioStatoPratica);

    let diff = now.diff(lastUpdated, 'days');

    let hasBeenUpdatedInTheLast3Days = diff <= 2;

    let isFieldAssigned: StatoPratica[] = [
      StatoPratica.APERTA,
      StatoPratica.CONFERMATA,
      StatoPratica.RICHIESTA_INTEGRAZIONI,
      StatoPratica.IN_RICHIESTA_DOCUMENTALE,
    ];

    const isNotAssignedFieldSet =
      currentUser?.ruoli.includes('Responsabile') &&
      !isFieldAssigned.includes(data.praticaResponse.stato);

    let garanteQuickEditStates: StatoPratica[] = [
      StatoPratica.DELIBERA_MCC,
      StatoPratica.PRENOTATA_STIPULA,
      StatoPratica.IN_STIPULA,
    ];

    let eroganteQuickEditStates: StatoPratica[] = [StatoPratica.IN_STIPULA];
    this.isDayOfStipula = isInStipula || false;
    this.hasBeenUpdatedInTheLast3Days = hasBeenUpdatedInTheLast3Days;
    this.initials = !isNotAssignedFieldSet
      ? (data.user?.nome?.charAt(0) || '') +
        (data.user?.cognome?.charAt(0) || '')
      : '';

    this.fullName = !isNotAssignedFieldSet
      ? `${data.user?.nome || ''} ${data.user?.cognome || ''} `
      : '';

    if (
      garanteQuickEditStates.includes(data.praticaResponse.stato) &&
      currentUser?.canaleId === data.garanteResponse?.id
    ) {
      this.isBoGaranteQuickEdit = true;
    } else if (
      eroganteQuickEditStates.includes(data.praticaResponse.stato) &&
      currentUser?.canaleId === data.eroganteResponse?.id
    ) {
      this.isBoEroganteQuickEdit = true;
    } else if (
      garanteQuickEditStates.includes(data.praticaResponse.stato) &&
      currentUser?.ruoli.includes('Amministratore') &&
      currentUser.groups.includes(ChannelType.CENTROCOMPENTENZA)
    ) {
      this.isCdcQuickEdit = true;
    }

    if(data.praticaResponse.stato === StatoPratica.PROPOSTA_MODIFICA &&
      (currentUser?.ruoli.includes('Addetto') || 
      currentUser?.ruoli.includes('Responsabile'))) {
        this.displayState = StatoPratica.IN_VALUTAZIONE_GARANZIA
      } else {
        this.displayState = data.praticaResponse.stato
      }
  }
}
